export default __webpack_public_path__ + "media/src/assets/images/barcode-a9ed7753794a61582bd6783f0689467a.png";